const validateMIMSToken = function(MIMSToken, MIMSTokenExpiredTimestamp) {
  if (!MIMSToken || !MIMSTokenExpiredTimestamp) return false;
  const dateNow = new Date();
  if (MIMSTokenExpiredTimestamp < dateNow.getTime()) return false;
  return true;
};

const setMIMSTokenExpiredTime = function(expires_in) {
  const date = new Date();
  let expiry;
  if (expires_in) {
    expiry = date.getTime() + 0.5 * expires_in * 1000;
  } else {
    expiry = date.getTime() + 0.9 * 60 * 60 * 1000;
  }
  return expiry;
};

const getQuantityOfMedicationText = function(productPackNameString) {
  let indexOfLastSquareBracketLeft = productPackNameString.lastIndexOf("[");
  let indexOfLastSquareBracketRight = productPackNameString.lastIndexOf("]");
  if (indexOfLastSquareBracketLeft > 0 && indexOfLastSquareBracketRight > 0) {
    let slicedQuantityOfMedication = productPackNameString
      .slice(indexOfLastSquareBracketLeft)
      .trim();
    let indexOfLastMultipleSign = slicedQuantityOfMedication.lastIndexOf("x");
    let slicedQuantityOfMedicationNumberBase = productPackNameString
      .slice(indexOfLastSquareBracketLeft + 1, indexOfLastSquareBracketRight)
      .trim();
    if (indexOfLastMultipleSign > 0) {
      let multiplierString = slicedQuantityOfMedication
        .slice(indexOfLastMultipleSign + 1)
        .trim();
      return slicedQuantityOfMedicationNumberBase + " x " + multiplierString;
    } else {
      return slicedQuantityOfMedicationNumberBase;
    }
  } else {
    return "-";
  }
};

const removeDuplicate = function(arr) {
  let newArray = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr.indexOf(arr[i]) === i) {
      newArray.push(arr[i]);
    }
  }
  return newArray;
};

const getMinValueFromArray = function(arr) {
  let intArr = arr.map(function(item) {
    if (item.includes("x")) {
      item = item.split("x")[1].trim();
    }
    return parseInt(item);
  });
  intArr.sort(function(a, b) {
    return a - b;
  });
  return intArr[0];
};

const getMedQuantityFromPBSDetails = function(pbsBrands) {
  let medQtyArrayFromPBSDetails = [];

  pbsBrands.forEach((item, index) => {
    const productPacks = item.productPacks;
    if (productPacks && productPacks.length > 0) {
      productPacks.forEach((productPack, key) => {
        medQtyArrayFromPBSDetails.push(
          getQuantityOfMedicationText(productPack.productPackName)
        );
      });
    }
  });

  medQtyArrayFromPBSDetails = removeDuplicate(medQtyArrayFromPBSDetails);
  const medQuantitySelectFromPBSDetails = medQtyArrayFromPBSDetails;
  const minMedQuantity = getMinValueFromArray(medQtyArrayFromPBSDetails);

  return { medQuantitySelectFromPBSDetails, minMedQuantity };
};

const translateMedQuantityToNumber = function(medQuantityString) {
  if (!isNaN(medQuantityString)) {
    return parseInt(medQuantityString);
  }
  const indexOfMultipleSign = medQuantityString.indexOf("x");
  if (indexOfMultipleSign < 0 && !isNaN(parseInt(medQuantityString))) {
    return parseInt(medQuantityString);
  } else {
    const multiplier = parseInt(
      medQuantityString.slice(indexOfMultipleSign + 1).trim()
    );
    const baseNumber = parseInt(
      medQuantityString.slice(0, indexOfMultipleSign).trim()
    );
    return baseNumber * multiplier;
  }
};

const handleRestrictionText = function(PBSRestrictions) {
  if (PBSRestrictions[0].restrictionType === "Unrestricted") return [];

  let restrictionList = [];

  PBSRestrictions.forEach((item, key) => {
    let restrictionItem = {};
    restrictionItem.restrictionType = item.restrictionType || "";
    restrictionItem.streamlinedCode = item.streamlinedCode || "";
    restrictionItem.firstSentence =
      getFirstSentence(item.restrictionText) || "";
    restrictionItem.clinicalCriteria =
      getClinicalCriteria(item.restrictionText) || "";
    restrictionItem.populationCriteria =
      getPopulationCriteria(item.restrictionText) || "";
    if (
      restrictionItem.streamlinedCode ||
      restrictionItem.firstSentence ||
      restrictionItem.clinicalCriteria
    ) {
      restrictionList.push(restrictionItem);
    }
  });

  return restrictionList;
};

const getFirstSentence = function(restrictionText) {
  let indexOfBrTag = restrictionText.indexOf("<br />");
  let textBeforeBrTag = "";
  if (indexOfBrTag === -1) {
    textBeforeBrTag = restrictionText.slice(0);
  } else {
    textBeforeBrTag = restrictionText.slice(0, indexOfBrTag);
  }
  textBeforeBrTag = decodeHtml(textBeforeBrTag);
  let indexOfSATagEnd = textBeforeBrTag.indexOf("</SA>");
  if (indexOfSATagEnd > -1) {
    let firstSentence = textBeforeBrTag.slice(indexOfSATagEnd + 5).trim();
    return removeLastPunctuation(firstSentence);
  } else {
    return removeLastPunctuation(textBeforeBrTag);
  }
};

const decodeHtml = function(str) {
  const map = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#039;": "'",
    superscript: "sup"
  };
  return str.replace(/&amp;|&lt;|&gt;|&quot;|&#039;|superscript/g, function(m) {
    return map[m];
  });
};

const removeLastPunctuation = function(str) {
  let strLength = str.length;
  if (!(strLength > 0)) return;

  let lastIndexOfComma = str.lastIndexOf(",");
  if (lastIndexOfComma === strLength - 1) {
    let slicedStr = str.slice(0, lastIndexOfComma);
    slicedStr = slicedStr + "...";
    return slicedStr;
  }

  let lastIndexOfFullstop = str.lastIndexOf(".");
  if (lastIndexOfFullstop === strLength - 1) {
    let slicedStr = str.slice(0, lastIndexOfFullstop);
    return slicedStr;
  }

  let lastIndexOfSemicolon = str.lastIndexOf(";");
  if (lastIndexOfSemicolon === strLength - 4) {
    let slicedStr = str.slice(0, lastIndexOfSemicolon);
    slicedStr = slicedStr + "...";
    return slicedStr;
  }

  return str;
};

const getClinicalCriteria = function(restrictionText) {
  let indexOfClinicalCriteria = restrictionText.indexOf("Clinical criteria:");
  let resList = restrictionText.slice(indexOfClinicalCriteria).split("<br />");
  let firstSentenceAfterClinicalCriteria = resList[1];
  if (firstSentenceAfterClinicalCriteria) {
    // firstSentenceAfterClinicalCriteria = firstSentenceAfterClinicalCriteria.replace(/superscript/g, 'sup');
    firstSentenceAfterClinicalCriteria = decodeHtml(
      firstSentenceAfterClinicalCriteria
    );
    return removeLastPunctuation(firstSentenceAfterClinicalCriteria);
  } else {
    return "";
  }
};

const getPopulationCriteria = function(restrictionText) {
  let indexOfPopulationCriteria = restrictionText.indexOf(
    "Population criteria:"
  );
  let resList = restrictionText
    .slice(indexOfPopulationCriteria)
    .split("<br />");
  let firstSentenceAfterPopulationCriteria = resList[1];
  if (firstSentenceAfterPopulationCriteria) {
    // firstSentenceAfterPopulationCriteria = firstSentenceAfterPopulationCriteria.replace(/superscript/g, 'sup');
    firstSentenceAfterPopulationCriteria = decodeHtml(
      firstSentenceAfterPopulationCriteria
    );
    return removeLastPunctuation(firstSentenceAfterPopulationCriteria);
  } else {
    return "";
  }
};

const getStreamlinedText = function(str) {
  let indexOfBRTagHead = str.indexOf("<br");
  let indexOfSATagEnd = str.indexOf("</SA>") + 5;
  return str.slice(indexOfSATagEnd, indexOfBRTagHead);
};

const wordsTranslate = function(data) {
  var num = data;
  var a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "Eleven ",
    "Twelve ",
    "Thirteen ",
    "Fourteen ",
    "Fifteen ",
    "Sixteen ",
    "Seventeen ",
    "Eighteen ",
    "Nineteen "
  ];
  var b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety"
  ];

  if ((num = num.toString()).length > 9) return "overflow";
  var n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return;
  var str = "";
  str +=
    n[1] != 0
      ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
      : "";
  str +=
    n[2] != 0
      ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
      : "";
  str +=
    n[3] != 0
      ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
      : "";
  str +=
    n[4] != 0
      ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
      : "";
  str +=
    n[5] != 0
      ? (str != "" ? "and " : "") +
        (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
        ""
      : "";
  str = str.slice(0, -1);
  return str;
};

const splitCodeFromSAC = function(SACString) {
  if (!SACString || SACString.length === 0) return SACString;
  return SACString.trim().split(" ")[0];
};

const firstLetterUpperCase = function(str) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, function(letter) {
    return letter.toUpperCase();
  });
};

export {
  validateMIMSToken,
  setMIMSTokenExpiredTime,
  getQuantityOfMedicationText,
  removeDuplicate,
  getMinValueFromArray,
  getMedQuantityFromPBSDetails,
  translateMedQuantityToNumber,
  handleRestrictionText,
  getStreamlinedText,
  wordsTranslate,
  splitCodeFromSAC,
  firstLetterUpperCase
};
